// extracted by mini-css-extract-plugin
export default {"ui-table":"styles__ui-table___Pq0Sc"};